import { ProjectType } from "./signup";

export enum HomeRecommendedProduct {
  Subgraphs = "subgraphs",
  Webhooks = "webhooks",
  GasManager = "gas-manager",
  AccountsManager = "accounts-manager",
  TxSimulation = "tx-simulation",
  TokenApi = "token-api",
  NftApi = "nft-api",
}

type Recommendations = [HomeRecommendedProduct, HomeRecommendedProduct];

export const recommendationsByProjectType: Record<
  ProjectType,
  Recommendations
> = {
  [ProjectType.Analytics]: [
    HomeRecommendedProduct.Subgraphs,
    HomeRecommendedProduct.Webhooks,
  ],
  [ProjectType.Defi]: [
    HomeRecommendedProduct.Subgraphs,
    HomeRecommendedProduct.TokenApi,
  ],
  [ProjectType.Gaming]: [
    HomeRecommendedProduct.Subgraphs,
    HomeRecommendedProduct.Webhooks,
  ],
  [ProjectType.Wallet]: [
    HomeRecommendedProduct.AccountsManager,
    HomeRecommendedProduct.GasManager,
  ],
  [ProjectType.Security]: [
    HomeRecommendedProduct.TxSimulation,
    HomeRecommendedProduct.Webhooks,
  ],
  [ProjectType.Marketplace]: [
    HomeRecommendedProduct.NftApi,
    HomeRecommendedProduct.Webhooks,
  ],
  [ProjectType.Social]: [
    HomeRecommendedProduct.NftApi,
    HomeRecommendedProduct.Webhooks,
  ],
  [ProjectType.InfraAndTooling]: [
    HomeRecommendedProduct.Webhooks,
    HomeRecommendedProduct.Subgraphs,
  ],
};

export const otherProjectRecommendations: Recommendations = [
  HomeRecommendedProduct.Webhooks,
  HomeRecommendedProduct.NftApi,
];
